// 彙整人數表
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  peopleStatisticsList,
} from '../store/action';


class Consolidation extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    let { date } = this.props;
    this.props.peopleStatisticsList(date);
  }


  render() {
    var peopleStatisticsStatee = {};
    let { peopleStatisticsState } = this.props;

    var startIdx = 0;
    var times = [];
    let visibleColumnsIndices = []; // 用於儲存可見欄位的索引

    if(peopleStatisticsState.dateData.administrationFullTimeCount.length === 0) return null;
    else
    {
      peopleStatisticsStatee = peopleStatisticsState.dateData;

      startIdx = peopleStatisticsStatee.time.findIndex(t => t === "06:00");
      times = startIdx !== -1 ? peopleStatisticsStatee.time.slice(startIdx) : peopleStatisticsStatee.time;

      // --- 計算哪些時段的欄位應該被顯示 ---
      const originalTimes = peopleStatisticsStatee.time;
      const currentTimes = times; // 這是從 06:00 開始的時段陣列

      for (let i = 0; i < currentTimes.length; i++) {
          const originalIndex = startIdx !== -1 ? startIdx + i : i;
          let columnHasNonZeroCount = false;

          // 檢查外場部門的計數
          const isOutfieldDepartmentSelected = peopleStatisticsStatee.department === 'All' || peopleStatisticsStatee.department === 'Outfield';
          if (isOutfieldDepartmentSelected) {
              if (peopleStatisticsStatee.outfieldManagementCount[originalIndex] !== 0 ||
                  peopleStatisticsStatee.outfieldFullTimeCount[originalIndex] !== 0 ||
                  peopleStatisticsStatee.outfieldPartTimeCount[originalIndex] !== 0) {
                  columnHasNonZeroCount = true;
              }
          }

          // 檢查內場部門的計數
          const isInfieldDepartmentSelected = peopleStatisticsStatee.department === 'All' || peopleStatisticsStatee.department === 'Infield';
          if (isInfieldDepartmentSelected) {
              if (peopleStatisticsStatee.infieldManagementCount[originalIndex] !== 0 ||
                  peopleStatisticsStatee.infieldFullTimeCount[originalIndex] !== 0 ||
                  peopleStatisticsStatee.infieldPartTimeCount[originalIndex] !== 0) {
                  columnHasNonZeroCount = true;
              }
          }

          // 檢查吧檯部門的計數
          const isBarDepartmentSelected = peopleStatisticsStatee.department === 'All' || peopleStatisticsStatee.department === 'Bar';
          if (isBarDepartmentSelected) {
              if (peopleStatisticsStatee.barManagementCount[originalIndex] !== 0 ||
                  peopleStatisticsStatee.barFullTimeCount[originalIndex] !== 0 ||
                  peopleStatisticsStatee.barPartTimeCount[originalIndex] !== 0) {
                  columnHasNonZeroCount = true;
              }
          }

          // 檢查行政部門的計數
          const isAdminDepartmentSelected = peopleStatisticsStatee.department === 'All';
          if (isAdminDepartmentSelected) {
              if (peopleStatisticsStatee.administrationFullTimeCount[originalIndex] !== 0) {
                  columnHasNonZeroCount = true;
              }
          }

          if (columnHasNonZeroCount) {
              visibleColumnsIndices.push(i);
          }
      }
      // --- 結束計算哪些時段的欄位應該被顯示 ---
    }

    // --- 新增：判斷每個數據行是否應該顯示 ---
    // 輔助函數：檢查一個數據陣列在可見欄位中是否有非零值
    const getRowContentVisibility = (dataArray) => {
        const filteredData = dataArray.slice(startIdx).filter((_, index) => visibleColumnsIndices.includes(index));
        return filteredData.some(item => item !== 0);
    };

    // 外場部門的行可見性判斷
    const isOutfieldDepartmentSelected = peopleStatisticsStatee.department === 'All' || peopleStatisticsStatee.department === 'Outfield';
    const showOutfieldManagementRow = isOutfieldDepartmentSelected && getRowContentVisibility(peopleStatisticsStatee.outfieldManagementCount);
    const showOutfieldFullTimeRow = isOutfieldDepartmentSelected && getRowContentVisibility(peopleStatisticsStatee.outfieldFullTimeCount);
    const showOutfieldPartTimeRow = isOutfieldDepartmentSelected && getRowContentVisibility(peopleStatisticsStatee.outfieldPartTimeCount);

    let outfieldRowSpan = 0;
    if (showOutfieldManagementRow) outfieldRowSpan++;
    if (showOutfieldFullTimeRow) outfieldRowSpan++;
    if (showOutfieldPartTimeRow) outfieldRowSpan++;
    const showOutfieldDepartmentBlock = outfieldRowSpan > 0; // 只要有任何子行可見，就顯示整個部門區塊

    // 內場部門的行可見性判斷
    const isInfieldDepartmentSelected = peopleStatisticsStatee.department === 'All' || peopleStatisticsStatee.department === 'Infield';
    const showInfieldManagementRow = isInfieldDepartmentSelected && getRowContentVisibility(peopleStatisticsStatee.infieldManagementCount);
    const showInfieldFullTimeRow = isInfieldDepartmentSelected && getRowContentVisibility(peopleStatisticsStatee.infieldFullTimeCount);
    const showInfieldPartTimeRow = isInfieldDepartmentSelected && getRowContentVisibility(peopleStatisticsStatee.infieldPartTimeCount);

    let infieldRowSpan = 0;
    if (showInfieldManagementRow) infieldRowSpan++;
    if (showInfieldFullTimeRow) infieldRowSpan++;
    if (showInfieldPartTimeRow) infieldRowSpan++;
    const showInfieldDepartmentBlock = infieldRowSpan > 0;

    // 吧檯部門的行可見性判斷
    const isBarDepartmentSelected = peopleStatisticsStatee.department === 'All' || peopleStatisticsStatee.department === 'Bar';
    const showBarManagementRow = isBarDepartmentSelected && getRowContentVisibility(peopleStatisticsStatee.barManagementCount);
    const showBarFullTimeRow = isBarDepartmentSelected && getRowContentVisibility(peopleStatisticsStatee.barFullTimeCount);
    const showBarPartTimeRow = isBarDepartmentSelected && getRowContentVisibility(peopleStatisticsStatee.barPartTimeCount);

    let barRowSpan = 0;
    if (showBarManagementRow) barRowSpan++;
    if (showBarFullTimeRow) barRowSpan++;
    if (showBarPartTimeRow) barRowSpan++;
    const showBarDepartmentBlock = barRowSpan > 0;

    // 行政部門的行可見性判斷
    const isAdminDepartmentSelected = peopleStatisticsStatee.department === 'All';
    const showAdministrationFullTimeRow = isAdminDepartmentSelected && getRowContentVisibility(peopleStatisticsStatee.administrationFullTimeCount);
    const showAdministrationDepartmentBlock = showAdministrationFullTimeRow; // 行政部門只有一行

    // --- 結束新增判斷邏輯 ---
    
    return (
      <div className="u-consolidation">
        <div className="u-table-responsive">
          <table className="u-table u-table-border">
            <thead>
              <tr>
                <th></th>
                {
                  // 只顯示06:00之後且有非零計數的時段
                  times.filter((_, index) => visibleColumnsIndices.includes(index)).map((item, index) => <th key={index}>{item}</th>)
                }
              </tr>
            </thead>
            <tbody>
              {/* 外場部門 */}
              {showOutfieldDepartmentBlock && (
                <>
                  {showOutfieldManagementRow && (
                    <tr >
                      <td rowSpan={outfieldRowSpan} className="outfield">外場</td>
                      {
                        peopleStatisticsStatee.outfieldManagementCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="outfield">管理：{item}</td>)
                      }
                    </tr>
                  )}
                  {showOutfieldFullTimeRow && (
                    <tr >
                      {!showOutfieldManagementRow && <td rowSpan={outfieldRowSpan} className="outfield">外場</td>} {/* 如果管理行被隱藏，則在此行顯示 rowSpan td */}
                      {
                        peopleStatisticsStatee.outfieldFullTimeCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="outfield">正職：{item}</td>)
                      }
                    </tr>
                  )}
                  {showOutfieldPartTimeRow && (
                    <tr >
                      {!showOutfieldManagementRow && !showOutfieldFullTimeRow && <td rowSpan={outfieldRowSpan} className="outfield">外場</td>} {/* 如果管理和正職行都被隱藏，則在此行顯示 rowSpan td */}
                      {
                        peopleStatisticsStatee.outfieldPartTimeCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="outfield">兼職：{item}</td>)
                      }
                    </tr>
                  )}
                </>
              )}

              {/* 內場部門 */}
              {showInfieldDepartmentBlock && (
                <>
                  {showInfieldManagementRow && (
                    <tr >
                      <td rowSpan={infieldRowSpan} className="infield">內場</td>
                      {
                        peopleStatisticsStatee.infieldManagementCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="infield">管理：{item}</td>)
                      }
                    </tr>
                  )}
                  {showInfieldFullTimeRow && (
                    <tr >
                      {!showInfieldManagementRow && <td rowSpan={infieldRowSpan} className="infield">內場</td>}
                      {
                        peopleStatisticsStatee.infieldFullTimeCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="infield">正職：{item}</td>)
                      }
                    </tr>
                  )}
                  {showInfieldPartTimeRow && (
                    <tr >
                      {!showInfieldManagementRow && !showInfieldFullTimeRow && <td rowSpan={infieldRowSpan} className="infield">內場</td>}
                      {
                        peopleStatisticsStatee.infieldPartTimeCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="infield">兼職：{item}</td>)
                      }
                    </tr>
                  )}
                </>
              )}

              {/* 吧檯部門 */}
              {showBarDepartmentBlock && (
                <>
                  {showBarManagementRow && (
                    <tr >
                      <td rowSpan={barRowSpan} className="barfield">吧檯</td>
                      {
                        peopleStatisticsStatee.barManagementCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="barfield">管理：{item}</td>)
                      }
                    </tr>
                  )}
                  {showBarFullTimeRow && (
                    <tr >
                      {!showBarManagementRow && <td rowSpan={barRowSpan} className="barfield">吧檯</td>}
                      {
                        peopleStatisticsStatee.barFullTimeCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="barfield">正職：{item}</td>)
                      }
                    </tr>
                  )}
                  {showBarPartTimeRow && (
                    <tr >
                      {!showBarManagementRow && !showBarFullTimeRow && <td rowSpan={barRowSpan} className="barfield">吧檯</td>}
                      {
                        peopleStatisticsStatee.barPartTimeCount.slice(startIdx)
                          .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                          .map( (item,index) => <td key={index} className="barfield">兼職：{item}</td>)
                      }
                    </tr>
                  )}
                </>
              )}

              {/* 行政部門 */}
              {showAdministrationDepartmentBlock && (
                <tr >
                  <td rowSpan="1" className="adminfield">行政部門</td>
                  {
                    peopleStatisticsStatee.administrationFullTimeCount.slice(startIdx)
                      .filter((_, index) => visibleColumnsIndices.includes(index)) // 過濾數據
                      .map( (item,index) => <td key={index} className="adminfield">行政：{item}</td>)
                  }
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (store) => ({
  peopleStatisticsState: store.PeopleStatisticsState,
})


export default connect(mapStateToProps,{
  peopleStatisticsList,
})(Consolidation);